export default __webpack_public_path__ + "images/42018b08f93735a19b5b488053804e37-tampa_desktop.webp";